import * as React from 'react';
export const arrowsOutwardSvg = React.forwardRef(function arrowsOutwardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.5 2h-9A1.5 1.5 0 0 0 2 3.5v9A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 2ZM3.5.5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3h-9Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.76 3.5H8.35a.75.75 0 0 0 0 1.5h1.59L5 9.94v-1.6a.75.75 0 0 0-1.5 0v3.41a.75.75 0 0 0 .75.75h3.41a.75.75 0 1 0 0-1.5h-1.6l4.95-4.95v1.61a.75.75 0 0 0 1.5 0V4.25a.75.75 0 0 0-.75-.75Z',
    }),
  );
});
arrowsOutwardSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowsOutward = {
  category: 'icon',
  colorable: true,
  name: 'arrowsOutward',
  svg: arrowsOutwardSvg,
};
